<div class="flex justify-content-end gap-4 p-3 w-full mb-2">
    <button
        type="button"
        class="bg-transparent border-none w-2rem h-1rem flex align-items-center justify-content-center text-900"
        (click)="carousel?.navBackward($event)"
        aria-label="Previous"
    >
        <i class="pi pi-chevron-left text-2xl"></i>
    </button>
    <button
        type="button"
        class="bg-transparent border-none w-2rem h-1rem flex align-items-center justify-content-center text-900"
        (click)="carousel?.navForward($event)"
        aria-label="Next"
    >
        <i class="pi pi-chevron-right text-2xl"></i>
    </button>
</div>

<div class="relative" appSwipeScroll>
    <p-carousel #carousel
                class="draggable feat"
                [value]="steps"
                [numScroll]="1"
                [numVisible]="numVisible"
                [responsiveOptions]="responsiveOptions2"
                [showIndicators]="false"
                [showNavigators]="false"
    >
        <ng-template let-step pTemplate="item">
            <div class="steps">
                <div class="deal-info">
                    <h3>{{ step.title }}</h3>
                    <p class="discount">{{ step.text }}</p>
                </div>
                <img [src]="step.image" [alt]="step.title"/>
            </div>
        </ng-template>
    </p-carousel>
</div>
